// @ts-check

/** @file Project board control availability presentation. */

/**
 * Determines whether board controls can act on an available board replica.
 * @param {{loading: boolean, notFound: boolean, projectSyncUnavailable: boolean, queryFailed: boolean}} state Board screen availability state.
 * @returns {boolean} Whether board controls can be rendered safely.
 */
export function projectBoardControlsAvailable({loading, notFound, projectSyncUnavailable, queryFailed}) {
  return !loading && !notFound && !projectSyncUnavailable && !queryFailed
}
